function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Tag"
}, /*#__PURE__*/React.createElement("path", {
  d: "M228.8 233.9H0V49.6h228.8l54.7 58.2v67.9l-54.7 58.2zM28.3 205.5h188.2l38.6-41V119l-38.6-41H28.3v127.5z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "219.8",
  cy: "141.7",
  r: "14.2"
}))));